import React from 'react';
import { Flag } from 'lucide-react';
interface NeedsFlagProps {
  children: React.ReactNode;
  className?: string;
}
export function NeedsFlag({
  children,
  className = ''
}: NeedsFlagProps) {
  return <p className={`inline-flex items-center gap-1.5 text-xs font-medium text-amber-800 ${className}`} data-id="element-2556" data-mp="7qcavsspavx1">
      <Flag className="h-3.5 w-3.5 shrink-0" data-id="element-2557" data-mp="2z3ycnw2qufn" />
      {children}
    </p>;
}